export enum EmploymentSituation {
    AS_EMPLOYEE = 'AJ',
    RECIPIENT_SUBSIDIES = 'SB',
    SELF_EMPLOYED = 'PR',
    UNPAID_ACTIVITY = 'NR',
    PENSION = 'PN',
    UNEMPLOYMENT ='DS',
    RENTS ='RT'
}
